// src/hooks/useRoom.ts
import { useState, useEffect } from "react";
import {
  isValidRoomId,
  getYoutubeVideoId,
  getRoomIdFromUrl,
} from "../utils/url";

export function useRoom() {
  const [roomId, setRoomId] = useState<string | null>(null);
  const [isValidRoom, setIsValidRoom] = useState<boolean>(false);
  const [isYoutubeRoom, setIsYoutubeRoom] = useState<boolean>(false);
  const [youtubeVideoId, setYoutubeVideoId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true); // Track initial loading

  useEffect(() => {
    const currentRoomId = getRoomIdFromUrl();
    setRoomId(currentRoomId);

    if (!currentRoomId) {
      // No room ID in URL, we are on the entry page
      setIsValidRoom(false);
      setIsYoutubeRoom(false);
      setYoutubeVideoId(null);
    } else {
      const isValid = isValidRoomId(currentRoomId);
      setIsValidRoom(isValid);

      if (isValid) {
        const videoId = getYoutubeVideoId(currentRoomId);
        if (videoId) {
          setIsYoutubeRoom(true);
          setYoutubeVideoId(videoId);
        } else {
          setIsYoutubeRoom(false);
          setYoutubeVideoId(null);
        }
      } else {
        // Room ID exists but is not a valid URL
        setIsYoutubeRoom(false);
        setYoutubeVideoId(null);
        // Redirect happens in the main App component based on this state
      }
    }
    setIsLoading(false); // Finished initial check
  }, []); // Runs once on mount

  return {
    roomId,
    isValidRoom,
    isYoutubeRoom,
    youtubeVideoId,
    isLoading, // Expose loading state
  };
}
